import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { CustomerTableState, OrderType } from '../../../models';

const namespaced = true;

export default {
  namespaced,
  state() {
    return {
      storeTable: {
        pagination: {
          order: OrderType.DESC,
          page: 0,
          rowsPerPage: 5,
          sortBy: '',
          totalItems: 0,
          rowsPerPageItems: [5, 10, 25],
        },
        items: [],
        loading: false,
      } as CustomerTableState,
    };
  },
  actions,
  getters,
  mutations,
};
